import Vue from 'vue';
import config from './env.js';
var baseUrl_online = config.baseURL;
// var baseUrl_online = "https://train.aojuai.com";


var uploadUrl = ""; //文件上传路径

var onlinePhoto = ""; //线上图片预览

var login = "/opportunity/user/doLogin"; //登录

/* !! 以后写接口请按照下面↓这样写, 上面↑的保持简洁的队形 !! queryReportTitle*/
// $Post( $Api.login, { userName, userPassword }, '正在登陆...' );
export default {
  baseUrl_online,
  login,
  getSysKeyCanEditAuth: '/opportunity/sys-key/getSysKeyCanEditAuth', // 是否可以编辑权限模块
  getUserOperation: '/opportunity/user/getUserOperation', // 获取用户操作权限
  getUserProjectList: "/opportunity/user/getUserProjectList",
  updateBusinessAttr: '/opportunity/business-attr/updateBusinessAttr', // 更新选项
  addBusinessAttr: '/opportunity/business-attr/addBusinessAttr', // 新增选项
  addBusinessModelTopic: '/opportunity/business-model-topic/addBusinessModelTopic', // 新增题目
  getSysNoticeUnCount: '/trainingmsg/sys-notice-receive/getSysNoticeUnCount', 
  updateUserPassword: '/opportunity/user/updateUserPassword', 

  /* ↓ 分类管理 */
  // addClass: '/classification/addClass', // 新增分类
  // deleteClass: '/classification/deleteClass', // 删除分类
  // updateClass: '/classification/updateClass', // 更新分类
  // chooseClass: '/classification/chooseClass', // 选择分类( 用户选取分类 )
  // queryClass: '/classification/queryClassByLevel',// 查询分类列表
  /* ↑ 分类管理 */

};

/*
  在这里管理全局右侧菜单栏
    ① 如果需要在后面添加菜单和页面, 只需要按照↓以下样例仿写
    {
      name: "菜单的中文显示名称", // !!必填
      url : "菜单的路由跳转页面", // ??选填, 可填写页面的name名称, 如"login", 或者路由的path路径, 如"/login"
      icon: "菜单的显示图标",    //  ??选填, 可填写图标的Class类名, 如"el-icon-menu"或".el-icon-menu", 或者图标的ID, 如"#MySelfIcon"
      api : {
          "接口的英文别名(通常和接口的末尾相同,如addUser)": [    // 这是接口1
            "接口的真实路径, 如 /user/addUser",                // !!必填
            "接口所需参数1",                                   // ??选填
            "接口所需参数2",
            ...
          ],
          "接口的英文别名(通常和接口的末尾相同,如deleteUser)": [ // 这是接口2
            ...
          ],
      }
    }
    ② Api接口的字段标注类型: !!(必填字段) ??(可选字段)
    ③ 如果含有 api:{}, 那么会自动为你解析并挂到对应的路由Vue页面, 此时你定义的所有字段包括函数如addUser(){}都无需在那个页面的data和methods里面重新定义了!!
      在没有复杂逻辑的情况下, 可以为你减少大量的代码量, 只需在你的vue页面里面绑定触发方法 @click='addUser()', 会自动将请求的数据挂载到你的主表格中!!
*/
const W = window;
/*const Menus2 = [
  // 用户登录注册----------------------------------------------------------------------------------------------------------------------
  {
    'show': 0,
    name: '登录页面',
    url: 'login',
    icon: 'el-icon-switch-button',
    api: {
      'getVerifyCode': [
        '/user/getVerifyCode|正在获取验证码..',
        'utel ?手机号',
      ],
    },
  },

  // 权限管理----------------------------------------------------------------------------------------------------------------------
  {
    name: '权限管理',
    icon: 'el-icon-s-flag',
    'show': true,
    submenus: [
      {
        name: '权限列表',
        url:  'AuthList',
        icon: 'el-icon-s-check',
        api: {
          'getAuthList1': [
            '/opportunity/auth/getAuthList|正在查询..',
            'currentPage', // !!当前页
            'pageSize', // !!每页条数
          ],
          'getAuthList2': 'getAuthList1',
          'getAuthList3': 'getAuthList1',
          'updateAtuh': [
            '/opportunity/auth/updateAuth|正在修改权限..',
            'authId !菜单权限主键',
          ],
        },
      },
    ]
  },

];*/

const Menus = W.$Menus || ( W.$Menus = [] ); Menus._parsed = Menus.customMenu = null;

const $forObj = forObj, $myClone = myClone;
const Apis = Menus.Apis = W.Apis = { __proto__: null };
const Apisurl = Menus.Apisurl = { __proto__: null };
let Chinamenus = Menus.Chinamenus = { __proto__: null }, Englishmenus = Menus.Englishmenus = { __proto__: null };

Menus.parse = function() {
  this._parsed = true;
  const customMenu = this.customMenu;
  if( customMenu ) this[this.length] = customMenu;
  Chinamenus   = Menus.Chinamenus = { __proto__: null };
  Englishmenus = Menus.Englishmenus = { __proto__: null }, Menus.updateEn && Menus.updateEn();
  forLoop(this, (each, api, b, parent, $rule) => {
    each.parent = parent || this, each.hideProperty("$rule", $rule = {});
    const $this = each.$this = {
      __proto__: null
    };
    // console.error(each.name,each.url);
    $forObj((Chinamenus[each.name] = Englishmenus[each.url || each.name] = each).api, (params, apiname, tip, apirule) => {
      var copy;
      if( typeof params === 'string' ) {
        // console.error(params);
        // if( params[0] !== '/' ) return Apis[apiname] = Apis[params]; // console.error(apiname,Apis[apiname],Apis[params]);
        // console.error(Apis,params,Apis[params]);
        if( params[0] === '/' ) params = [params];
        else { if( ( copy = Apis[params] ) == null ) return; params = copy.slice(); };
      };
      tip = params[0].split('|');
      if (!Apisurl[apirule = tip[0].trim()]) {
        Apisurl[params[0] = apirule] = apiname;
      } else {
        // console.error(tip, apiname, apirule);
        // console.error(Apis.getAuthList);
        if (!Apisurl[apirule += ' ']) {
          // if( apiname === 'getAuthList2' ) return console.error(apiname, params);
          Apisurl[params[0] = apirule] = apiname;
        } else {
          while (true) {
            if (!Apisurl[apirule += ' ']) {
              Apisurl[params[0] = apirule] = apiname;
              break;
            };
          };
        };
        // console.error(Apis.getAuthList);
      };
      // console.error(apiname);
      (apirule = Apis[apiname]) ? apirule["$same_apis"].push(params) : Apis[apiname] = params;
      params["$same_apis"] = [];
      params['$this'] = (params['$thismenu'] = each).$this = $this;
      if( copy ) {
        params["$rule"] = copy["$rule"], params.$tip = copy.$tip;
        $forObj(copy,(v,k)=>{
          if( -1 < k || k[0] === '$' ) return;
          params[k] = v;
        });
        return;
      };
      params["$rule"] = apirule = {};
      params.$tip = tip[1] || '';
      params.slice(1).forEach((v, i, s, b, label) => {
        if (
          v !== (s = v.split(b = '!'))[0] ||
          v !== (s = v.split(b = '?'))[0]
        ) {
          v = s[0].trim(), label = s[1].trim();
          v = params[i + 1] = (s = v.split(':'))[0].trim();
          params[v] = s.length === 1 ? '' : s[1].trim();
          ($rule[v] = apirule[v] = (
            b === '?' ? [] : [{
              required: true,
              message: label + "不能为空!",
              trigger: "blur"
            },
            {
              required: true,
              message: label + "不能为空!",
              trigger: "change"
            },
            {
              required: true,
              message: label + "不能为空!",
              trigger: "submit"
            },
            ]
          )).label = label;
        } else {
          v = params[i + 1] = (s = v.split(':'))[0].trim();
          params[v] = s.length === 1 ? '' : s[1].trim();
        };

      });
    });
  }, 'submenus');
  if( customMenu ) this.length--;
  return;
};
// Menus.parse();
// console.error(Menus);

Menus.add = (menu, before) => {
  typeof before === 'number' ? before : forLoop(Menus, (arr, i) => (i = arr.findIndex(v => v.name === '角色管理')) > -1 && [arr, i], 'submenus')
};

Menus.closemenu = () => {
  const actived = Menus.actived;
  if (actived) {
    actived.opened = [];
    actived.index = "";
  };
};

Menus.toggleCollapse = () => {
  const actived = Menus.actived;
  W.parseInt(actived.width) > actived.defaultWidth
    ? actived.width = actived.defaultWidth
    : actived.collapse = !actived.collapse;
};

Menus.getPath = (menu) => {
  var url = menu.url || '';
  return menu.path = url[0] === '/' ? url : (url = W.$Routernames[url]) ? url.path : '';
};


const $errors = (() => {
  const tickObj = {
    __proto__: null,
    count: 0,
    times: 0,
    waitNextick: false
  },
    console = W.console,
    setTimeout = W.setTimeout;
  const $errors = function (times, ...args) {
    if (tickObj.waitNextick) return NaN;
    tickObj.times === 0 && (tickObj.times = typeof times === 'number' ? times : (args = [times, ...args], 1));
    tickObj.times > tickObj.count++
      &&
      (
        times !== null ? console.error(...args) : console.error(times, ...args),
        tickObj.waitNextick = true,
        setTimeout(v => tickObj.waitNextick = tickObj.times = tickObj.count = 0, 0)
      );
  };
  $errors.tickObj = tickObj;
  return $errors;
})();

W.Vue = Vue;


console.log('I am api.js');

W.ONFILE = "https://www.yingxiaozhushou.com/ysFile/"; // 线上文件地址



// WEBPACK FOOTER //
// ./src/utils/api.js